// Centralized API route builders to prevent path drift
export const apiRoutes = {
  // Profile
  profile: '/api/profile',
  profileMetros: (state: string) => `/api/profile/metros?state=${encodeURIComponent(state)}`,
  profilePrefs: '/api/profile/prefs',
  profileUsage: (take: number) => `/api/profile/usage?take=${encodeURIComponent(String(take))}`,
  profileChangePassword: '/api/profile/change-password',

  // Verification (account identity verification flows)
  verifyIdentity: '/api/profile/verify/identity',
  verifyCurrent: '/api/profile/verify-current',
  verificationStatus: '/api/profile/verification/status',
  verificationIdPresign: '/api/profile/verification/id/presign',
  verificationIdComplete: '/api/profile/verification/id/complete',
  verificationSignaturePresign: '/api/profile/verification/signature/presign',
  verificationSignatureComplete: '/api/profile/verification/signature/complete',
  verificationVideoPresign: '/api/profile/verification/video/presign',
  verificationVideoComplete: '/api/profile/verification/video/complete',
  verificationSubmit: '/api/profile/verification/submit',

  // People/Person
  personById: (id: string | number) => `/api/person/${encodeURIComponent(String(id))}`,
  personDetail: (id: string | number) => `/api/person/${encodeURIComponent(String(id))}/detail`,
  peopleByUser: (userId: string) => `/api/people/by-user/${encodeURIComponent(userId)}`,
  peopleLike: (id: string | number) => `/api/people/${encodeURIComponent(String(id))}/like`, // PeopleController owns like/unlike

  // Onboarding
  onboardingStatus: '/api/onboarding/status',
};
